import { render, staticRenderFns } from "./Conclusions.vue?vue&type=template&id=6013adbc&scoped=true&"
import script from "./Conclusions.vue?vue&type=script&lang=js&"
export * from "./Conclusions.vue?vue&type=script&lang=js&"
import style0 from "./Conclusions.vue?vue&type=style&index=0&id=6013adbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6013adbc",
  null
  
)

export default component.exports